//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface ErrorViewModel {
    message: string;
    error?: string | undefined;
    stackTrace?: string | undefined;
}

export interface UserIdentity {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
}

export interface AppUser extends UserIdentity {
    roles?: AppUserRole[] | undefined;
    groups?: UserGroupItem[] | undefined;
    subscription?: Subscription | undefined;
}

export interface AppUserRole {
    id: UserRoleType;
    name: string;
}

export enum UserRoleType {
    Customer = 1024,
    Internal = 16384,
    SuperAdministrator = 82944,
}

export interface UserGroupItem {
    id: string;
    name: string;
    isInternal: boolean;
    type: GroupType;
    companyId: string;
    rights?: TeamRight | undefined;
}

export enum GroupType {
    Company = 0,
    Team = 1,
    AllInCompany = -1,
}

export enum TeamRight {
    None = 0,
    EditProjects = 64,
}

export interface Subscription {
    userId: string;
    tier: SubscriptionTier;
    expirationDate: Date;
}

export enum SubscriptionTier {
    NoAccess = 0,
    Trial = 1,
    Permanent = 2,
}

export interface CircularityRateViewModel {
    windfarmMaterialBreakdown: MaterialsBreakdownViewModel;
    circularityWeights: CircularityWeightsViewModel;
    cablesWeights: CablesWeightsViewModel;
    onshoreOffshoreWeights: OnshoreOffshoreWeightsViewModel;
    floatingWeights: FloatingWeightsViewModel;
    onshoreSubstationWeights: OnshoreSubstationWeightsViewModel;
    cablesTableData: CableRecyclabilityViewModel;
    foundationsTableData: FoundationRecyclabilityViewModel;
    floatersTableData: FloaterRecyclabilityViewModel;
    mooringLinesTableData: MooringLinesRecyclabilityViewModel;
    anchorsTableData: AnchorsRecyclabilityViewModel;
}

export interface MaterialsBreakdownViewModel {
    steel: number;
    castIron: number;
    copper: number;
    componentType: ComponentType;
    aluminium: number;
    rareEarths: number;
    glassFibre: number;
    epoxyResin: number;
    purpvcFoam: number;
    balsaWood: number;
    epoxyGelcoat: number;
    silicon: number;
    other: number;
    total: number;
    steelRecoveryRate: number;
    castIronRecoveryRate: number;
    copperRecoveryRate: number;
    aluminiumRecoveryRate: number;
    rareEarthsRecoveryRate: number;
    glassFibreRecoveryRate: number;
    epoxyResinRecoveryRate: number;
    purpvcFoamRecoveryRate: number;
    balsaWoodRecoveryRate: number;
    epoxyGelcoatRecoveryRate: number;
    siliconRecoveryRate: number;
    otherRecoveryRate: number;
    totalRecoveryRate: number;
    steelRecoveredMassT: number;
    castIronRecoveredMassT: number;
    copperRecoveredMassT: number;
    aluminiumRecoveredMassT: number;
    rareEarthsRecoveredMassT: number;
    glassFibreRecoveredMassT: number;
    epoxyResinRecoveredMassT: number;
    purpvcFoamRecoveredMassT: number;
    balsaWoodRecoveredMassT: number;
    epoxyGelcoatRecoveredMassT: number;
    siliconRecoveredMassT: number;
    otherRecoveredMassT: number;
    totalRecoveredMassT: number;
    createdBy: string;
    createdAt: Date;
    updatedAt: Date;
    updatedBy: string;
}

export enum ComponentType {
    Blades = 0,
    Hub = 1,
    Nacelle = 2,
    Tower = 3,
    Total = 4,
}

export interface CircularityWeightsViewModel {
    turbineTotalMaterialWeightT: number;
    turbineCircularityRate: number;
    turbineRecoveredMaterialWeight: number;
    windfarmTotalMaterialWeightT: number;
    windfarmCircularityRate: number;
    windfarmRecoveredMaterialWeight: number;
}

export interface CablesWeightsViewModel {
    arrayCablesTotalWeightT: number;
    arrayCablesMetalWeightT: number;
    arrayCablesMetalPercentage: number;
    arrayCablesOtherWeightT: number;
    arrayCablesOtherPercentage: number;
    exportCablesTotalWeightT: number;
    exportCablesMetalWeightT: number;
    exportCablesMetalPercentage: number;
    exportCablesOtherWeightT: number;
    exportCablesOtherPercentage: number;
}

export interface OnshoreOffshoreWeightsViewModel {
    foundationsTotalWeightT: number;
    foundationsSteelWeightT: number;
    foundationsSteelPercentage: number;
    foundationsConcreteWeightT: number;
    foundationsConcretePercentage: number;
    foundationsOtherWeightT: number;
    foundationsOtherPercentage: number;
}

export interface FloatingWeightsViewModel {
    floaterTotalWeightT: number;
    floaterSteelWeightT: number;
    floaterSteelPercentage: number;
    floaterConcreteWeightT: number;
    floaterConcretePercentage: number;
    floaterOtherWeightT: number;
    floaterOtherPercentage: number;
    mooringLinesTotalWeightT: number;
    mooringLinesSteelWeightT: number;
    mooringLinesSteelPercentage: number;
    mooringLinesOtherWeightT: number;
    mooringLinesOtherPercentage: number;
    anchorsTotalWeightT: number;
    anchorsMetalWeightT: number;
    anchorsMetalPercentage: number;
}

export interface OnshoreSubstationWeightsViewModel {
    onshoreSubstationTotalWeightT: number;
    onshoreSubstationSteelWeightT: number;
    onshoreSubstationSteelWeightPercentage: number;
    onshoreSubstationConcreteWeightT: number;
    onshoreSubstationConcreteWeightPercentage: number;
    onshoreSubstationCopperWeightT: number;
    onshoreSubstationCopperWeightPercentage: number;
    onshoreSubstationAluminiumWeightT: number;
    onshoreSubstationAluminiumWeightPercentage: number;
    onshoreSubstationOtherWeightT: number;
    onshoreSubstationOtherWeightPercentage: number;
}

export interface CableRecyclabilityViewModel {
    arrayCablesMetalWeightT: number;
    exportCablesMetalWeightT: number;
    arrayCablesMetalRecoveryRate: number;
    exportCablesMetalRecoveryRate: number;
    arrayCablesRecoveredMetalWeightT: number;
    exportCablesRecoveredMetalWeightT: number;
    arrayCablesOtherWeightT: number;
    exportCablesOtherWeightT: number;
    arrayCablesRecoveredOtherWeightT: number;
    exportCablesRecoveredOtherWeightT: number;
    arrayCablesOtherRecoveryRate: number;
    exportCablesOtherRecoveryRate: number;
    arrayCablesTotalRecoveryRate: number;
    exportCablesTotalRecoveryRate: number;
    arrayCablesMetalName: string;
    exportCablesMetalName: string;
}

export interface FoundationRecyclabilityViewModel {
    totalRecoveryRate: number;
    windFarmMetalMassT: number;
    metalRecoveryRate: number;
    recoveredMetalMassT: number;
    windFarmConcreteMassT: number;
    concreteRecoveryRate: number;
    recoveredConcreteMassT: number;
    windFarmOtherMassT: number;
    otherRecoveryRate: number;
    recoveredOtherMassT: number;
}

export interface FloaterRecyclabilityViewModel {
    totalRecoveryRate: number;
    windFarmMetalMassT: number;
    metalRecoveryRate: number;
    recoveredMetalMassT: number;
    windFarmConcreteMassT: number;
    concreteRecoveryRate: number;
    recoveredConcreteMassT: number;
    windFarmOtherMassT: number;
    recoveredOtherMassT: number;
    otherRecoveryRate: number;
}

export interface MooringLinesRecyclabilityViewModel {
    totalRecoveryRate: number;
    windFarmMetalMassT: number;
    metalRecoveryRate: number;
    recoveredMetalMassT: number;
    windFarmConcreteMassT: number;
    concreteRecoveryRate: number;
    recoveredConcreteMassT: number;
    windFarmOtherMassT: number;
    recoveredOtherMassT: number;
    otherRecoveryRate: number;
}

export interface AnchorsRecyclabilityViewModel {
    totalRecoveryRate: number;
    windFarmMetalMassT: number;
    metalRecoveryRate: number;
    recoveredMetalMassT: number;
}

export interface PlantWeightsViewModel {
    windfarmMaterialBreakdown: MaterialsBreakdownViewModel;
    circularityWeights: CircularityWeightsViewModel;
    cablesWeights: CablesWeightsViewModel;
    onshoreOffshoreWeights: OnshoreOffshoreWeightsViewModel;
    floatingWeights: FloatingWeightsViewModel;
    onshoreSubstationWeights: OnshoreSubstationWeightsViewModel;
}

export interface CountryViewModel {
    id: string;
    name: string;
    code: string;
    location: CoordinatesViewModel;
    defaultCurrency: CurrencyViewModel;
}

export interface CoordinatesViewModel {
    longitude: number;
    latitude: number;
}

export interface CurrencyViewModel {
    id: string;
    name: string;
    currencyInformation: CurrencyInformationViewModel;
    exchangeRateToDefaultCurrency: number;
    updatedAt: Date;
}

export interface CurrencyInformationViewModel {
    unit: string;
    formattingMask: string;
    symbol: string;
}

export interface CostCalculationConfigurationRegisterViewModel {
    isDefault: boolean;
    reversible: boolean;
    name: string;
    currency: CurrencyViewModel;
    onshoreCostCalculationConfigurationSet: OnshoreCostCalculationConfigurationSetViewModel;
    offshoreFloatingCostCalculationConfigurationSet: OffshoreFloatingCostCalculationConfigurationSetViewModel;
    offshoreBottomFixedCostCalculationConfigurationSet: OffshoreBottomFixedCostCalculationConfigurationSetViewModel;
    lastEdit: Date;
}

export interface CostCalculationConfigurationSetViewModel {
    parameterType: ParameterType;
}

export interface OnshoreCostCalculationConfigurationSetViewModel extends CostCalculationConfigurationSetViewModel {
    parameters: { [key in keyof typeof OnshoreDisplayGroup]?: OnshoreParameterViewModel[]; };
}

export enum OnshoreDisplayGroup {
    ReinstateAndRemoval = 0,
    TurbineDisassemblyAssumptions = 1,
    MaterialCosts = 2,
    FoundationRemoval = 3,
    Reinstate = 4,
    ProjectOverheads = 5,
    TurbineDisposal = 6,
    PlantHireCosts = 7,
    Cranes = 8,
}

export interface ParameterViewModel {
    isCost: boolean;
    min: number;
    max: number;
    isVisibleForUser: boolean;
    name: string;
    displayName: string;
    description: string;
    canUserUpdate: boolean;
    currencyInformation: CurrencyInformationViewModel;
    doubleValue: number;
}

export interface OnshoreParameterViewModel extends ParameterViewModel {
    displayGroup: OnshoreDisplayGroup;
    inputGroup: OnshoreInputGroup;
}

export enum OnshoreInputGroup {
    General = 0,
    EquipmentCost = 1,
    EquipmentOtherSharedData = 2,
    UnitCostsForMaterials = 3,
    TurbineDisposal = 4,
    ProjectOverheads = 5,
    FoundationRemoval = 6,
    Reinstate = 7,
    Activities = 8,
    TurbineRemoval = 9,
    TurbineDisassembly = 10,
    RotorDisassembly = 11,
    NacelleAndHubDisassembly = 12,
    TowerDisassembly = 13,
    TransformerDisassembly = 14,
    DisposalCosts = 15,
    CableRemoval = 16,
    OnSiteConstructions = 17,
    ScrapWaste = 18,
}

export enum ParameterType {
    Onshore = 0,
    OffshoreBottomFixed = 1,
    OffshoreFloating = 2,
    DateTime = 3,
    String = 4,
    Double = 5,
}

export interface OffshoreFloatingCostCalculationConfigurationSetViewModel extends CostCalculationConfigurationSetViewModel {
    parameters: { [key in keyof typeof OffshoreFloatingDisplayGroup]?: OffshoreFloatingParameterViewModel[]; };
}

export enum OffshoreFloatingDisplayGroup {
    General = 0,
}

export interface OffshoreFloatingParameterViewModel extends ParameterViewModel {
    inputGroup: OffshoreFloatingInputGroup;
    displayGroup: OffshoreFloatingDisplayGroup;
}

export enum OffshoreFloatingInputGroup {
    General = 0,
}

export interface OffshoreBottomFixedCostCalculationConfigurationSetViewModel extends CostCalculationConfigurationSetViewModel {
    parameters: { [key in keyof typeof OffshoreFixedDisplayGroup]?: OffshoreFixedParameterViewModel[]; };
}

export enum OffshoreFixedDisplayGroup {
    RemovalOfExportCable = 0,
    RemovalOfFoundations = 1,
    Vessel = 2,
    PreparationForRemoval = 3,
    RemovalOfOffshoreSubstation = 4,
    MobilisationDemobilisation = 5,
    RemovalOfArrayCables = 6,
    OverheadCosts = 7,
    ScrapWaste = 8,
}

export interface OffshoreFixedParameterViewModel extends ParameterViewModel {
    displayGroup: OffshoreFixedDisplayGroup;
    inputGroup: OffshoreFixedInputGroup;
}

export enum OffshoreFixedInputGroup {
    General = 0,
    Phases = 1,
    FoundationsRelatedPhases = 2,
    CablesRelatedPhases = 3,
    DismantlingAndTransportationOfOffshoreWindTurbinesPhase = 4,
    RemovalOfArrayCablesPhase = 5,
    PreparationForRemovalOfFoundationsPhase = 6,
    RemovalOfFoundationsPhase = 7,
    RemovalOfExportCablePhase = 8,
    RemovalOfOffshoreSubstationPhase = 9,
    SmallJackUpBarge = 10,
    MediumJackUpBage = 11,
    LargeJackUpBarge = 12,
    NextGenerationJackUpBarge = 13,
    CableLayingVessel = 14,
    HeavilyLoadCarrier = 15,
    SemiSubCraneVessel = 16,
    SubstationInstallationVessel = 17,
    Barge = 18,
    OverheadCosts = 19,
    ScrapWaste = 20,
}

export interface CostCalculationOnshoreConfigurationRegisterViewModel {
    projectType: ProjectType;
    isDefault: boolean;
    reversible: boolean;
    name: string;
    currency: CurrencyViewModel;
    lastEdit: Date;
    costCalculationConfigurationSet: OnshoreCostCalculationConfigurationSetViewModel;
}

export enum ProjectType {
    Onshore = 0,
    OffshoreBottomFixed = 1,
    OffshoreFloating = 2,
}

export interface CostCalculationOffshoreFixedConfigurationRegisterViewModel {
    projectType: ProjectType;
    isDefault: boolean;
    reversible: boolean;
    name: string;
    currency: CurrencyViewModel;
    lastEdit: Date;
    costCalculationConfigurationSet: OffshoreBottomFixedCostCalculationConfigurationSetViewModel;
}

export interface CostCalculationOffshoreFloatingConfigurationRegisterViewModel {
    projectType: ProjectType;
    isDefault: boolean;
    reversible: boolean;
    name: string;
    currency: CurrencyViewModel;
    lastEdit: Date;
    costCalculationConfigurationSet: OffshoreFloatingCostCalculationConfigurationSetViewModel;
}

export interface CountryWithConfigurationsViewModel extends CountryViewModel {
    costCalculationConfiguration: CostCalculationConfigurationRegisterViewModel;
    configurationId: string;
}

export interface ParameterUpdateModel {
    name: string;
    value: number;
    type: ProjectType;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface OffshoreFixedCostCalculationViewModel {
    dismantlingAndTransportationOfOffshoreWindTurbines: OffshoreCostRemovalOfTurbineAndFoundationViewModel;
    preparationForRemovalOfFoundations: OffshoreCostRemovalOfTurbineAndFoundationViewModel;
    removalOfFoundations: OffshoreCostRemovalOfTurbineAndFoundationViewModel;
    removalOfArrayCables: OffshoreCostRemovalOfCablesViewModel;
    removalOfExportCable: OffshoreCostRemovalOfCablesViewModel;
    removalOfOffshoreSubstation: OffshoreCostRemovalOfSubstationViewModel;
    isManual: boolean;
    toolsAndJigs: CostViewModel;
    preDecommissioningSurveys: CostViewModel;
    postDecommissioningSurveys: CostViewModel;
    projectManagement: CostViewModel;
    harbourCosts: CostViewModel;
    backOfficeResources: CostViewModel;
    personnelTransferAndSafetyVessels: CostViewModel;
    metalScrapValue: CostViewModel;
    totalEngineeringCosts: CostViewModel;
    totalOverheadCosts: CostViewModel;
    totalCosts: CostViewModel;
    netTotalCosts: CostViewModel;
    updatedAt: Date;
}

export interface OffshoreCostRemovalOfTurbineAndFoundationViewModel {
    offshoreCostViewModel: OffshoreCostViewModel;
    dayRate: DayRateCrewEquipmentViewModel;
    total: CostViewModel;
}

export interface OffshoreCostViewModel {
    numberOfTurbines: number;
    ratedPowerMW: number;
    mobilisation: CostViewModel;
    demobilisation: CostViewModel;
    operatingDuration: number;
    fixedCosts: CostViewModel;
}

export interface CostViewModel {
    absolute: number;
    perTurbine: number;
    perMW: number;
}

export interface DayRateVesselFuelViewModel {
    vesselAndStaff: CostViewModel;
    fuel: CostViewModel;
    total: CostViewModel;
}

export interface DayRateCrewEquipmentViewModel extends DayRateVesselFuelViewModel {
    crew: CostViewModel;
    equipment: CostViewModel;
}

export interface OffshoreCostRemovalOfCablesViewModel {
    offshoreCostViewModel: OffshoreCostViewModel;
    dayRate: DayRateDeburialViewModel;
    total: CostViewModel;
}

export interface DayRateDeburialViewModel extends DayRateCrewEquipmentViewModel {
    deBurial: CostViewModel;
}

export interface OffshoreCostRemovalOfSubstationViewModel {
    dayRate: DayRateBargeTugSetupViewModel;
    offshoreCostViewModel: OffshoreCostViewModel;
    total: CostViewModel;
}

export interface DayRateBargeTugSetupViewModel extends DayRateVesselFuelViewModel {
    bargeTugSetup: CostViewModel;
}

export interface UpdateOffshoreFixedCostCalculationViewModel {
    removalOfArrayCables: UpdateOffshoreCostRemovalOfCablesViewModel;
    removalOfOffshoreSubstation: UpdateOffshoreCostRemovalOfSubstationViewModel;
    removalOfExportCable: UpdateOffshoreCostRemovalOfCablesViewModel;
    dismantlingAndTransportationOfOffshoreWindTurbines: UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel;
    preparationForRemovalOfFoundations: UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel;
    removalOfFoundations: UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel;
    preDecommissioningSurveys: number;
    postDecommissioningSurveys: number;
    projectManagement: number;
    harbourCosts: number;
    backOfficeResources: number;
    personnelTransferAndSafetyVessels: number;
    toolsAndJigs: number;
    metalScrapValue: number;
}

export interface UpdateOffshoreCostRemovalOfCablesViewModel {
    updateOffshoreCostViewModel: UpdateOffshoreCostViewModel;
    vesselAndStaff: number;
    fuel: number;
    crew: number;
    equipment: number;
    deBurial: number;
}

export interface UpdateOffshoreCostViewModel {
    mobilisation: number;
    demobilisation: number;
    operatingDuration: number;
}

export interface UpdateOffshoreCostRemovalOfSubstationViewModel {
    updateOffshoreFixedCostViewModel: UpdateOffshoreCostViewModel;
    vesselAndStaff: number;
    fuel: number;
    bargeTugSetup: number;
}

export interface UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel {
    updateOffshoreCostViewModel: UpdateOffshoreCostViewModel;
    vesselAndStaff: number;
    fuel: number;
    crew: number;
    equipment: number;
}

export interface OffshoreFloatingCostCalculationViewModel {
    removingTurbineUnitTransportationToPortDissasembly: OffshoreCostRemovalOfTurbineAndFoundationViewModel;
    mooringSystemAndAnchorRemoval: OffshoreCostRemovalOfTurbineAndFoundationViewModel;
    removalOfArrayCables: OffshoreCostRemovalOfCablesViewModel;
    removalOfExportCable: OffshoreCostRemovalOfCablesViewModel;
    removalOfOffshoreSubstation: OffshoreCostRemovalOfSubstationViewModel;
    isManual: boolean;
    seaFasteningForOSS: CostViewModel;
    preDecommissioningSurveys: CostViewModel;
    postDecommissioningSurveys: CostViewModel;
    projectManagement: CostViewModel;
    harbourCosts: CostViewModel;
    backOfficeResources: CostViewModel;
    personnelTransferAndSafetyVessels: CostViewModel;
    metalScrapValue: CostViewModel;
    totalEngineeringCosts: CostViewModel;
    totalOverheadCosts: CostViewModel;
    totalCosts: CostViewModel;
    netTotalCosts: CostViewModel;
    updatedAt: Date;
}

export interface UpdateOffshoreFloatingCostCalculationViewModel {
    removalOfArrayCables: UpdateOffshoreCostRemovalOfCablesViewModel;
    removalOfOffshoreSubstation: UpdateOffshoreCostRemovalOfSubstationViewModel;
    removalOfExportCable: UpdateOffshoreCostRemovalOfCablesViewModel;
    removingTurbineUnitTransportationToPortDissasembly: UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel;
    mooringSystemAndAnchorRemoval: UpdateOffshoreCostRemovalOfTurbineAndFoundationViewModel;
    seaFasteningForOSS: number;
    preDecommissioningSurveys: number;
    postDecommissioningSurveys: number;
    projectManagement: number;
    harbourCosts: number;
    backOfficeResources: number;
    personnelTransferAndSafetyVessels: number;
    metalScrapValue: number;
}

export interface SaveOnboardingModel {
    role: OnboardingRole;
    understandMaterialBreakdown: boolean;
    understandDecommissioningCosts: boolean;
    estimateTurbineResidualValue: boolean;
    understandCircularity: boolean;
    discoverNewRecyclingMethodsAndFacilities: boolean;
    anotherGoal: string;
}

export enum OnboardingRole {
    AssetManagement = 0,
    ProductionAndDevelopment = 1,
    Sustainability = 2,
    Finance = 3,
    Procurement = 4,
}

export interface OnshoreCostCalculationViewModel {
    disassemblyCost: CostViewModel;
    removalCost: CostViewModel;
    materialDisposalCost: CostViewModel;
    bladeDisposalCost: CostViewModel;
    turbineFoundationsDisposalCost: CostViewModel;
    cableRemovalCost: CostViewModel;
    removalOfOtherOnSiteConstructions: CostViewModel;
    accessRoadsRemovalCost: CostViewModel;
    cranePadsRemovalCost: CostViewModel;
    reinstateCost: CostViewModel;
    projectOverheadCost: CostViewModel;
    metalScrapValue: CostViewModel;
    totalCosts: CostViewModel;
    netTotalCosts: CostViewModel;
    isManual: boolean;
    updatedAt: Date;
}

export interface UpdateOnshoreCostCalculationViewModel {
    disassemblyCost: number;
    removalCost: number;
    materialDisposalCost: number;
    bladeDisposalCost: number;
    turbineFoundationsDisposalCost: number;
    cableRemovalCost: number;
    removalOfOtherOnSiteConstructions: number;
    accessRoadsRemovalCost: number;
    cranePadsRemovalCost: number;
    reinstateCost: number;
    projectOverheadCost: number;
    metalScrapValue: number;
}

export interface CreateProjectViewModel {
    name: string;
    isDraft: boolean;
    projectType: ProjectType;
    countryId?: string | undefined;
    description?: string | undefined;
}

export interface ProjectSimpleItemViewModel {
    id: string;
    name: string;
    projectType: ProjectType;
    isDraft: boolean;
    companyName: string;
}

export interface ProjectItemViewModel extends ProjectSimpleItemViewModel {
    countryId?: string | undefined;
    countryName?: string | undefined;
    description?: string | undefined;
    createdBy: string;
    createdAt: Date;
    updatedBy: string;
    scenarios: ScenarioSimpleItemViewModel[];
    updatedAt: Date;
    turbineApplication: ApplicationType;
    turbineName?: string | undefined;
    turbineManufacturer?: string | undefined;
    turbineModelNumber?: string | undefined;
    turbineId?: string | undefined;
    installationDate?: Date | undefined;
    numberOfTurbines?: number | undefined;
    location?: CoordinatesViewModel | undefined;
    address?: string | undefined;
    dateOfCommissioning?: Date | undefined;
    assumedEndOfLifeDate?: Date | undefined;
    accessRoadLengthKm: number;
    accessRoadWidthM: number;
    accessRoadDepthM: number;
    cranePadLengthM: number;
    cranePadWidthM: number;
    cranePadDepthM: number;
    exportCableType?: CableType | undefined;
    foundationVolumeM3: number;
    hasHvSubstation: boolean;
    metMastNumber: number;
    arrayCableLengthKm: number;
    arrayCableSizeKV: number;
    arrayCableMaterial?: CableMaterial | undefined;
    exportCableLengthKm: number;
    exportCableSizeKV: number;
    exportCableMaterial?: CableMaterial | undefined;
    distanceToPortKm: number;
    averageWaterDepthM: number;
    hasOffshoreSubstation: boolean;
    foundationType?: FoundationType | undefined;
    foundationTotalWeightT: number;
    foundationSteelWeightT: number;
    foundationConcreteWeightT: number;
    foundationOtherWeightT: number;
    floaterTotalWeightT: number;
    floaterSteelWeightT: number;
    floaterConcreteWeightT: number;
    floaterOtherWeightT: number;
    primaryMooringLine?: MooringLineViewModel | undefined;
    secondaryMooringLine?: MooringLineViewModel | undefined;
    anchor?: AnchorViewModel | undefined;
    hasOnshoreSubstation: boolean;
    onshoreSubstationSteelWeightT: number;
    onshoreSubstationConcreteWeightT: number;
    onshoreSubstationCopperWeightT: number;
    onshoreSubstationAluminiumlWeightT: number;
    onshoreSubstationOtherWeightT: number;
    onshoreSubstationTotalWeightT: number;
}

export interface ScenarioSimpleItemViewModel {
    id: string;
    name: string;
    projectId?: string | undefined;
    projectName: string;
    createdAt: Date;
    updatedAt: Date;
    companyName: string;
}

export enum ApplicationType {
    Onshore = 0,
    Offshore = 1,
}

export enum CableType {
    Above = 0,
    Underground = 1,
}

export enum CableMaterial {
    Copper = 0,
    Aluminium = 1,
}

export enum FoundationType {
    Jacket = 0,
    Monopile = 1,
    GravityBased = 2,
    SuctionBucketJacket = 3,
}

export interface MooringLineViewModel {
    material: MooringLineMaterial;
    weightKgM: number;
    lengthM: number;
}

export enum MooringLineMaterial {
    Steel = 0,
    Polyester = 1,
    Nylon = 2,
}

export interface AnchorViewModel {
    material: AnchorMaterial;
    weightKg: number;
}

export enum AnchorMaterial {
    Steel = 0,
    CastIron = 1,
}

export interface UpdateProjectItemViewModel {
    name?: string | undefined;
    isDraft?: boolean | undefined;
    countryId?: string | undefined;
    description?: string | undefined;
    turbineApplication?: ApplicationType | undefined;
    turbineName?: string | undefined;
    turbineManufacturer?: string | undefined;
    turbineModelNumber?: string | undefined;
    turbineId?: string | undefined;
    installationDate?: Date | undefined;
    numberOfTurbines?: number | undefined;
    location?: CoordinatesViewModel | undefined;
    address?: string | undefined;
    dateOfCommissioning?: Date | undefined;
    assumedEndOfLifeDate?: Date | undefined;
    accessRoadLengthKm?: number | undefined;
    accessRoadWidthM?: number | undefined;
    accessRoadDepthM?: number | undefined;
    cranePadLengthM?: number | undefined;
    cranePadWidthM?: number | undefined;
    cranePadDepthM?: number | undefined;
    exportCableType?: CableType | undefined;
    foundationVolumeM3?: number | undefined;
    hasHvSubstation?: boolean | undefined;
    metMastNumber?: number | undefined;
    arrayCableLengthKm?: number | undefined;
    arrayCableSizeKV?: number | undefined;
    arrayCableMaterial?: CableMaterial | undefined;
    exportCableLengthKm?: number | undefined;
    exportCableSizeKV?: number | undefined;
    exportCableMaterial?: CableMaterial | undefined;
    distanceToPortKm?: number | undefined;
    averageWaterDepthM?: number | undefined;
    hasOffshoreSubstation?: boolean | undefined;
    foundationType?: FoundationType | undefined;
    foundationSteelWeightT?: number | undefined;
    foundationConcreteWeightT?: number | undefined;
    foundationOtherWeightT?: number | undefined;
    floaterSteelWeightT?: number | undefined;
    floaterConcreteWeightT?: number | undefined;
    floaterOtherWeightT?: number | undefined;
    primaryMooringLineMaterial?: MooringLineMaterial | undefined;
    primaryMooringLineLengthM?: number | undefined;
    primaryMooringLineWeightKgM?: number | undefined;
    secondaryMooringLineMaterial?: MooringLineMaterial | undefined;
    secondaryMooringLineLengthM?: number | undefined;
    secondaryMooringLineWeightKgM?: number | undefined;
    anchorWeightKg?: number | undefined;
    anchorMaterial?: AnchorMaterial | undefined;
    hasOnshoreSubstation?: boolean | undefined;
    onshoreSubstationSteelWeightT?: number | undefined;
    onshoreSubstationConcreteWeightT?: number | undefined;
    onshoreSubstationCopperWeightT?: number | undefined;
    onshoreSubstationAluminiumlWeightT?: number | undefined;
    onshoreSubstationOtherWeightT?: number | undefined;
}

export interface PaginatedListOfProjectItemViewModel {
    items: ProjectItemViewModel[];
    current: number;
    pageSize: number;
    total: number;
}

export interface CreateProviderViewModel {
    name: string;
    countryId: string;
    providerTypes: ProviderType;
    materials?: ProviderMaterial | undefined;
    services: ProviderService;
    status: ProviderStatus;
    websiteAddress: string;
    isDraft: boolean;
}

export enum ProviderType {
    None = 0,
    SecondLife = 1,
    MaterialProcessing = 2,
    Decommissioning = 4,
    Port = 8,
}

export enum ProviderMaterial {
    None = 0,
    Turbine = 1,
    Blades = 2,
    Concrete = 4,
    Metals = 8,
    RareEarths = 16,
    Oils = 32,
}

export enum ProviderService {
    None = 0,
    Recycling = 1,
    Repurposing = 2,
    ReSale = 4,
    Landfill = 8,
    Recovery = 16,
    TurnkeyDecommissioning = 32,
    Transport = 64,
    CraneServices = 128,
}

export enum ProviderStatus {
    Operating = 0,
    UnderConstruction = 1,
}

export interface ProviderItemViewModel {
    id: string;
    name: string;
    countryId?: string | undefined;
    countryName?: string | undefined;
    status: ProviderStatus;
    providerTypes: ProviderType;
    materials: ProviderMaterial;
    services: ProviderService;
    isDraft: boolean;
    websiteAddress: string;
    address?: string | undefined;
    hqAddress?: string | undefined;
    location?: CoordinatesViewModel | undefined;
    hqCountryName?: string | undefined;
    hqCountryId?: string | undefined;
    serviceCapacityTDay: number;
    operationalSinceYear?: Date | undefined;
    processDescription?: string | undefined;
    commercialPartners?: string | undefined;
    certification?: string | undefined;
    priceBladeProcessingEuroT: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface UpdateProviderViewModel {
    name?: string | undefined;
    countryId?: string | undefined;
    status?: ProviderStatus | undefined;
    providerTypes?: ProviderType | undefined;
    materials?: ProviderMaterial | undefined;
    services?: ProviderService | undefined;
    isDraft?: boolean | undefined;
    websiteAddress?: string | undefined;
    address?: string | undefined;
    hqAddress?: string | undefined;
    location?: CoordinatesViewModel | undefined;
    hqCountryId?: string | undefined;
    serviceCapacityTDay?: number | undefined;
    operationalSinceYear?: Date | undefined;
    processDescription?: string | undefined;
    commercialPartners?: string | undefined;
    certification?: string | undefined;
    priceBladeProcessingEuroT: number;
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface PaginatedListOfProviderItemViewModel {
    items: ProviderItemViewModel[];
    current: number;
    pageSize: number;
    total: number;
}

export interface Analysis {
    name: string;
    template_application: string;
    created_by: string;
    organisation: string;
    modified_by: string;
    state: string;
    inputs: Inputs[];
    environment_inputs: Environment_inputs[];
    driver_inputs: Driver_inputs[];
    task_id: string;
    messages: Message[];
    run_inputs: { [key: string]: { [key: string]: number; }; };
    results: any;
    figures: any;
    progress: any;
    progress_figures: any;
    start_time: number;
    finished_time: number;
    run_names_ids_map: { [key: string]: string; };
    runs_completed: string[];
    runs_failed: string[];
    _id: string;
    date_created: number;
    date_modified: number;
    application_name: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Inputs {
    name: string;
    items: Items[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Items {
    name: string;
    type: string;
    value: any;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    batch: boolean;
    unit: string;
    maximum: number;
    minimum: number;
    fields: Fields[];
    default: any;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Fields {
    name: string;
    type: string;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    enum: string[];
    unit: string;
    default: number[];
    items: Items3;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Items3 {
    name: string;
    type: string;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    unit: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Environment_inputs {
    name: string;
    items: items[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface items {
    name: string;
    type: string;
    value: any;
    description: string;
    path: string;
    section: string;
    display_group: string;
    enum: string[];
    title: string;
    visible: boolean;
    model: string;
    fields: fields[];
    default: Default;
    items: Items2;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface fields {
    name: string;
    type: string;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Default {
    convergence_parameter: string;
    start_model: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Items2 {
    name: string;
    type: string;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Driver_inputs {
    name: string;
    items: items2[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface items2 {
    name: string;
    type: string;
    value: any;
    description: string;
    path: string;
    section: string;
    display_group: string;
    title: string;
    visible: boolean;
    model: string;
    fields: any[];
    default: any;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Message {
    type: string;
    text: string;
    time: number;
    source: Source;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Source {
    source1: Source1;
    state: SourceState;
    type: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export enum Source1 {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export enum SourceState {
    Running = "Running",
    Failed = "Failed",
    Terminated = "Terminated",
    Cancelled = "Cancelled",
    Complete = "Complete",
}

export interface AnalysisRunResults {
    figures: Figures;
    results: Results;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Figures {
    blade_structure: Blade_structure;
    monopile: Monopile;
    power_curve: Power_curve;
    tower: Tower;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blade_structure {
    design: string;
    margins: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Monopile {
    overview: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Power_curve {
    results: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Tower {
    lengthwise_properties: string;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Results {
    rnA_cost: RNA_cost;
    rnA_dimensions: RNA_dimensions;
    rnA_mass: RNA_mass;
    bearing_loads: Bearing_loads;
    blade_cost: Blade_cost;
    blade_spanwise_loads: Blade_spanwise_loads;
    blade_structure: Blade_structure2;
    blade_to_pitch_bearing_bolted_connection: Blade_to_pitch_bearing_bolted_connection;
    blades_cost_total: Blades_cost_total;
    blades_mass_total: Blades_mass_total;
    downwind_bearing: Downwind_bearing;
    downwind_bearing_cost: Downwind_bearing_cost;
    generator: Generator;
    hub: Hub;
    hub_to_main_shaft_bolted_connection: Hub_to_main_shaft_bolted_connection;
    kingpin: Kingpin;
    kingpin_cost: Kingpin_cost;
    kingpin_length: Kingpin_length;
    kingpin_mainframe_bolted_connection: Kingpin_mainframe_bolted_connection;
    life_time_revolutions: Life_time_revolutions;
    mainframe: Mainframe;
    monopile: Monopile2;
    nacelle_balance_of_system: Nacelle_balance_of_system;
    nacelle_balance_of_system_cost: Nacelle_balance_of_system_cost;
    nacelle_balance_of_system_mass: Nacelle_balance_of_system_mass;
    nacelle_contingencies: Nacelle_contingencies;
    nacelle_cost: Nacelle_cost;
    nacelle_mass: Nacelle_mass;
    pitch_bearing: Pitch_bearing;
    pitch_bearing_cost_total: Pitch_bearing_cost_total;
    pitch_bearing_mass_total: Pitch_bearing_mass_total;
    pitch_system: Pitch_system;
    pitch_system_cost: Pitch_system_cost;
    pitch_system_cost_total: Pitch_system_cost_total;
    pitch_system_mass_total: Pitch_system_mass_total;
    pitch_total_cost: Pitch_total_cost;
    pitch_total_mass: Pitch_total_mass;
    power_circuit: Power_circuit;
    power_curve: Power_curve2;
    recyclability_spreadsheet: Recyclability_spreadsheet;
    rotor_aerodynamic_performance: Rotor_aerodynamic_performance;
    rotor_cost: Rotor_cost;
    rotor_gravity_induced_loads: Rotor_gravity_induced_loads;
    rotor_mass: Rotor_mass;
    rotor_speed_torque: Rotor_speed_torque;
    single_turbine_cost: Single_turbine_cost;
    site_specific_interface_loads: Site_specific_interface_loads;
    tower: Tower2;
    tower_length: Tower_length;
    tower_spanwise_loads: Tower_spanwise_loads;
    turbine_design_interface_loads: Turbine_design_interface_loads;
    turbine_design_wind_speed_distribution: Turbine_design_wind_speed_distribution;
    upwind_bearing: Upwind_bearing;
    upwind_bearing_cost: Upwind_bearing_cost;
    yaw_bearing: Yaw_bearing;
    yaw_bearing_to_mainframe_bolted_connection: Yaw_bearing_to_mainframe_bolted_connection;
    yaw_cost: Yaw_cost;
    yaw_mass: Yaw_mass;
    yaw_system: Yaw_system;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface RNA_cost {
    rnA_cost1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface RNA_dimensions {
    height_RNA_CoG_to_yaw_bearing: number;
    height_hub_centre_to_yaw_bearing: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface RNA_mass {
    nacelle_mass: number;
    rotor_mass: number;
    sum_factor: number;
    summed_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Bearing_loads {
    downwind_bearing_FZ_extreme: number;
    downwind_bearing_FZ_mean: number;
    downwind_bearing_My_extreme_stator: number;
    upwind_bearing_FZ_extreme: number;
    upwind_bearing_FZ_mean: number;
    upwind_bearing_My_extreme_stator: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blade_cost {
    cost: number;
    cost_CRP: number;
    cost_GRP: number;
    cost_balsa: number;
    cost_labour: number;
    cost_tooling: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blade_spanwise_loads {
    spanwise_loads: Spanwise_loads[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Spanwise_loads {
    nz: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blade_structure2 {
    cog: number;
    length: number;
    mass: number;
    material_masses: { [key: string]: string; };
    root_diameter: number;
    root_length: number;
    structural_definition: Structural_definition;
    structural_results: any[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Structural_definition {
    foils: any[];
    geo: any[];
    materials: any[];
    segment_layups: { [key: string]: any[]; };
    segmentation: any[];
    stacks: Stacks;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Stacks {
    materials: { [key: string]: string; };
    optimization_roles: { [key: string]: string; };
    thicknesses: any[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blade_to_pitch_bearing_bolted_connection {
    m: number;
    n: number;
    pcd: number;
    srF_extreme: number;
    srF_fatigue: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blades_cost_total {
    single_blade_cost: number;
    sum_factor: number;
    summed_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Blades_mass_total {
    single_blade_mass: number;
    sum_factor: number;
    summed_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Downwind_bearing {
    bearing_mass: number;
    bearing_width: number;
    inner_diameter: number;
    number_of_rollers: number;
    outer_diameter: number;
    width_rollers: number;
    width_rollers_dynamic: number;
    width_rollers_static: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Downwind_bearing_cost {
    cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Generator {
    cost: number;
    distance_upwind_bearing_to_rotor_COG: number;
    efficiency: Efficiency[];
    mass: number;
    rotor_mass: number;
    shaft_length: number;
    torque_mass: number;
    watt_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Efficiency {
    generator_efficiency: number;
    part_rating: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Hub {
    cost: number;
    main_shaft_flange_to_hub_centre_distance: number;
    mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Hub_to_main_shaft_bolted_connection {
    m: number;
    n: number;
    pcd: number;
    srF_extreme: number;
    srF_fatigue: number;
    srF_slip: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Kingpin {
    downwind_inner_diameter: number;
    downwind_inner_diameter_extreme_strength: number;
    downwind_inner_diameter_min_wall_thickness: number;
    downwind_outer_diameter: number;
    length: number;
    mass: number;
    upwind_inner_diameter: number;
    upwind_inner_diameter_extreme_strength: number;
    upwind_inner_diameter_min_wall_thickness: number;
    upwind_outer_diameter: number;
    volume: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Kingpin_cost {
    cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Kingpin_length {
    kingpin_length1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Kingpin_mainframe_bolted_connection {
    m: number;
    n: number;
    pcd: number;
    srF_extreme: number;
    srF_fatigue: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Life_time_revolutions {
    revolutions: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Mainframe {
    cost: number;
    mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Monopile2 {
    cost_total: number;
    embedded_length: number;
    financial: Financial;
    find_start_diameter_record: any[];
    fls_combined_loads: any[];
    fls_wave_loads: any[];
    fls_wind_loads: any[];
    load_z_coords: any[];
    mass_total: number;
    minimum_viable_diameter: number;
    monopile_base_diameter: number;
    monopile_length: number;
    monopile_mass: number;
    monopile_transition_piece_annulus_volume: number;
    mp_can_base_diams: any[];
    mp_can_lengths: any[];
    mp_can_thicknesses: any[];
    mp_can_top_diams: any[];
    mp_top_elevation_lat: number;
    mudline_elevation: number;
    natural_frequency: number;
    optimization_outputs: any[];
    rotation_utilization: number;
    secondary_steel_mass: Secondary_steel_mass;
    self_weight_length: number;
    tp_can_base_diams: any[];
    tp_can_lengths: any[];
    tp_can_thicknesses: any[];
    tp_can_top_diams: any[];
    tp_top_elevation_lat: number;
    transition_piece_length: number;
    transition_piece_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Financial {
    anodes_cost: number;
    coating_cost: number;
    monopile_cost: Primary_Steel_Cost;
    total_cost: number;
    total_primary_cost: Primary_Steel_Cost;
    total_secondary_cost: Total_secondary_cost;
    transition_piece_cost: Primary_Steel_Cost;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Primary_Steel_Cost {
    base_supply_cost: number;
    conical_cost: number;
    markup_cost: number;
    total_cost: number;
    weld_length_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Total_secondary_cost {
    airtight_platform_cost: number;
    fenders_cost: number;
    ladders_cost: number;
    lower_working_platform_cost: number;
    main_working_platform_cost: number;
    top_internal_platform_cost: number;
    total_cost: number;
    upper_rest_platform_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Secondary_steel_mass {
    airtight_platform_mass: number;
    fenders_mass: number;
    ladders_mass: number;
    lower_working_platform_mass: number;
    main_working_platform_mass: number;
    top_internal_platform_mass: number;
    total_mass: number;
    upper_rest_platform_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_balance_of_system {
    controls_cost: number;
    controls_mass: number;
    hydraulics_cost: number;
    hydraulics_mass: number;
    nacelle_cover_cost: number;
    nacelle_cover_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_balance_of_system_cost {
    controls_cost: number;
    hydraulics_cost: number;
    nacelle_cover_cost: number;
    sum_factor: number;
    summed_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_balance_of_system_mass {
    controls_mass: number;
    hydraulics_mass: number;
    nacelle_cover_mass: number;
    sum_factor: number;
    summed_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_contingencies {
    contingencies_cost: number;
    contingencies_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_cost {
    balance_of_system_cost: number;
    contingencies_cost: number;
    downwind_bearing_cost: number;
    generator_cost: number;
    inverter_cost: number;
    kingpin_cost: number;
    mainframe_cost: number;
    sum_factor: number;
    summed_cost: number;
    transformer_cost: number;
    upwind_bearing_cost: number;
    yaw_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Nacelle_mass {
    balance_of_system_mass: number;
    contingencies_mass: number;
    downwind_bearing_mass: number;
    generator_mass: number;
    inverter_mass: number;
    kingpin_mass: number;
    mainframe_mass: number;
    sum_factor: number;
    summed_mass: number;
    transformer_mass: number;
    upwind_bearing_mass: number;
    yaw_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_bearing {
    pcd: number;
    cost: number;
    hub_bolted_connection_PCD: number;
    mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_bearing_cost_total {
    number_of_blades: number;
    pitch_bearing_cost_per_blade: number;
    pitch_bearing_cost_total1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_bearing_mass_total {
    number_of_blades: number;
    pitch_bearing_mass_per_blade: number;
    pitch_bearing_mass_total1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_system {
    battery_capacity: number;
    battery_energy: number;
    battery_mass: number;
    battery_unit_mass: number;
    battery_voltage: number;
    gear_box_mass: number;
    gear_box_ratio: number;
    gear_box_torque: number;
    inverter_mass: number;
    inverter_unit_mass: number;
    mass: number;
    motor_mass: number;
    motor_torque: number;
    number_of_batteries: number;
    overturning_moment: number;
    pitch_rate: number;
    pitching_energy: number;
    pitching_power: number;
    pitching_torque: number;
    ratio_MXY_MZ: number;
    ratio_pinion_bearing: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_system_cost {
    battery_cost: number;
    controller_cost: number;
    cost: number;
    gear_box_cost: number;
    inverter_cost: number;
    motor_cost: number;
    slip_ring_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_system_cost_total {
    number_of_blades: number;
    pitch_system_cost_per_blade: number;
    pitch_system_cost_total1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_system_mass_total {
    number_of_blades: number;
    pitch_system_mass_per_blade: number;
    pitch_system_mass_total1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_total_cost {
    pitch_bearing_cost_total: number;
    pitch_cost: number;
    pitch_system_cost_total: number;
    sum_factor: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Pitch_total_mass {
    pitch_bearing_mass_total: number;
    pitch_mass: number;
    pitch_system_mass_total: number;
    sum_factor: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Power_circuit {
    cost_inverter: number;
    cost_transformer: number;
    inverter_efficiency: Inverter_efficiency[];
    inverter_input_power: number;
    mass_inverter: number;
    mass_transformer: number;
    transformer_efficiency: Transformer_efficiency[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Inverter_efficiency {
    inverter_efficiency1: number;
    part_rating: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Transformer_efficiency {
    part_rating: number;
    transformer_efficiency1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Power_curve2 {
    power_curve: power_curve[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface power_curve {
    efficiency_gearbox: number;
    efficiency_generator: number;
    efficiency_inverter: number;
    efficiency_transformer: number;
    part_rating: number;
    power: number;
    power_coefficient: number;
    power_electric_ex_turbulence_correction: number;
    power_shaft: number;
    power_shaft_ex_turbulence_correction: number;
    rotor_speed: number;
    thrust_coefficient: number;
    thrust_shaft: number;
    tip_speed_ratio: number;
    wind_speed: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Recyclability_spreadsheet {
    aluminium: number;
    aluminiumPercentage: number;
    anode_coating: number;
    blades: number;
    composites: number;
    compositesPercentage: number;
    copper: number;
    copperPercentage: number;
    foundation_mass: number;
    hub_structure: number;
    iron: number;
    ironPercentage: number;
    monopile: number;
    nacelle_assembly: number;
    nonRecyclables: number;
    other: number;
    otherPercentage: number;
    pitch_assembly: number;
    rna: number;
    recyclability: number;
    recyclables__metals: number;
    steel: number;
    steelPercentage: number;
    total: number;
    tower_total: number;
    transition_piece: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_aerodynamic_performance {
    rotor_efficiency: Rotor_efficiency[];
    thrust_coefficient: Thrust_coefficient[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_efficiency {
    power_coefficient: number;
    tip_speed_ratio: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Thrust_coefficient {
    thrust_coefficient1: number;
    tip_speed_ratio: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_cost {
    blades_cost: number;
    hub_cost: number;
    pitch_cost: number;
    sum_factor: number;
    summed_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_gravity_induced_loads {
    gravity_corrected_loads: Gravity_corrected_loads;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Gravity_corrected_loads {
    ehR_FYZ: number;
    fhR_FY4: number;
    fhR_FZ4: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_mass {
    blades_mass: number;
    hub_mass: number;
    pitch_mass: number;
    sum_factor: number;
    summed_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Rotor_speed_torque {
    min_rotor_speed: number;
    rated_rotor_speed: number;
    rated_torque: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Single_turbine_cost {
    rna_cost: number;
    sum_factor: number;
    summed_cost: number;
    tower_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Site_specific_interface_loads {
    derivation: { [key: string]: Load; };
    loads: { [key: string]: string; };
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Load {
    base: number;
    pitch_control_method_correction: number;
    power_density_correction: number;
    turbulence_correction: number;
    wind_speed_correction: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Tower2 {
    cog: number;
    d_base: number;
    d_top: number;
    n_cans: number;
    average_tower_section_mass: number;
    base_loads: { [key: string]: string; };
    base_moment_extreme: number;
    can_geometry: Can_geometry[];
    cans_cost: number;
    cost: number;
    diameter_optimization_log: any[];
    flanges: Flanges[];
    horizontal_flanges_cost: number;
    largest_tower_section_mass: number;
    length: number;
    markup_cost: number;
    mass: number;
    number_of_tower_sections: number;
    number_of_tower_segments: number;
    sections: Sections[];
    tower_internals_cost: number;
    tower_total_cost_per_kg: number;
    vertical_flanges_cost: number;
    wall_thickness_tower_bottom: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Can_geometry {
    base_diameter: number;
    length: number;
    margin_extreme_buckling: number;
    margin_extreme_yield: number;
    margin_fatigue: number;
    mass_per_unit_length: number;
    thickness: number;
    top_diameter: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Flanges {
    d_in: number;
    d_out: number;
    bolt_number: number;
    bolt_size: number;
    failure_mode: string;
    mass: number;
    moment: number;
    section: number;
    thickness: number;
    valid: boolean;
    width: number;
    z: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Sections {
    base_diameter: number;
    length: number;
    mass: number;
    number_of_segments: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Tower_length {
    tower_length1: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Tower_spanwise_loads {
    tower_base_loads: { [key: string]: string; };
    tower_spanwise_loads_distribution: Tower_spanwise_loads_distribution[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Tower_spanwise_loads_distribution {
    z: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Turbine_design_interface_loads {
    derivation: { [key: string]: Load; };
    loads: { [key: string]: string; };
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Turbine_design_wind_speed_distribution {
    windspeed_probability_distribution: Windspeed_probability_distribution[];
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Windspeed_probability_distribution {
    bin_width: number;
    probability: number;
    wind_speed: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Upwind_bearing {
    bearing_mass: number;
    bearing_width: number;
    inner_diameter: number;
    number_of_rollers: number;
    outer_diameter: number;
    width_rollers: number;
    width_rollers_dynamic: number;
    width_rollers_static: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Upwind_bearing_cost {
    cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Yaw_bearing {
    pcd: number;
    cost: number;
    main_frame_bolted_connection_PCD: number;
    mass: number;
    tower_bolted_connection_PCD: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Yaw_bearing_to_mainframe_bolted_connection {
    m: number;
    n: number;
    pcd: number;
    srF_extreme: number;
    srF_fatigue: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Yaw_cost {
    sum_factor: number;
    summed_cost: number;
    yaw_bearing_cost: number;
    yaw_system_cost: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Yaw_mass {
    sum_factor: number;
    summed_mass: number;
    yaw_bearing_mass: number;
    yaw_system_mass: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Yaw_system {
    cost: number;
    cost_brake: number;
    cost_drive: number;
    mass: number;
    mass_brake: number;
    mass_drive: number;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export interface Run {
    name: string;
    id: string;
    state: RunState;
    additionalProperties: { [key: string]: any; };

    [key: string]: any;
}

export enum RunState {
    Running = "Running",
    Failed = "Failed",
    Terminated = "Terminated",
    Cancelled = "Cancelled",
    Complete = "Complete",
}

export interface CreateScenarioViewModel {
    name: string;
    projectId?: string | undefined;
}

export interface PaginatedListOfScenarioItemViewModel {
    items: ScenarioItemViewModel[];
    current: number;
    pageSize: number;
    total: number;
}

export interface ScenarioItemViewModel extends ScenarioSimpleItemViewModel {
    project?: ProjectSimpleItemViewModel | undefined;
    metalProcessingProviderId?: string | undefined;
    bladeProcessingProviderId?: string | undefined;
    concreteProcessingProviderId?: string | undefined;
    metalProcessingProviderName?: string | undefined;
    bladeProcessingProviderName?: string | undefined;
    concreteProcessingProviderName?: string | undefined;
    currency: CurrencyViewModel;
    decommissionOffshoreBottomFixedScopeId?: string | undefined;
    decommissionOffshoreFloatingScopeId?: string | undefined;
    decommissionOnshoreScopeId?: string | undefined;
    decommissionOffshoreBottomFixedScope: DecommissionOffshoreBottomFixedScopeViewModel;
    decommissionOffshoreFloatingScope: DecommissionOffshoreFloatingScopeViewModel;
    decommissionOnshoreScope: DecommissionOnshoreScopeViewModel;
    isDraft: boolean;
    useDefaultProviders: boolean;
    includeScrapValue: boolean;
}

export interface DecommissionOffshoreBottomFixedScopeViewModel {
    offshoreSubstationToBeRemoved?: boolean | undefined;
    cableCrossingProtectionToBeRemoved?: boolean | undefined;
    exportCablesToBeRemoved?: boolean | undefined;
    subSeaArrayCablesToBeRemoved?: boolean | undefined;
    scourProtectionToBeRemoved?: boolean | undefined;
    pilesBelowSeaBedToBeRemoved?: boolean | undefined;
    scenarioId: string;
    foundationsToBeRemoved?: boolean | undefined;
}

export interface DecommissionOffshoreFloatingScopeViewModel {
    scenarioId: string;
    floaterToBeRemoved?: boolean | undefined;
    mooringLinesToBeRemoved?: boolean | undefined;
    offshoreSubstationToBeRemoved?: boolean | undefined;
    cableCrossingProtectionToBeRemoved?: boolean | undefined;
    exportCablesToBeRemoved?: boolean | undefined;
    subSeaArrayCablesToBeRemoved?: boolean | undefined;
}

export interface DecommissionOnshoreScopeViewModel {
    scenarioId: string;
    accessRoadsToBeRemoved?: boolean | undefined;
    geotextilesBeneathTheRoadToBeRemoved?: boolean | undefined;
    levelCranePadsAtEachTurbineBaseToBeRemoved?: boolean | undefined;
    geotextilesBeneathTheCranePadToBeRemoved?: boolean | undefined;
    cablesNeedToBeRemoved?: boolean | undefined;
    topSoilStorageAreaOnSitePossible?: boolean | undefined;
    hVsubstationNeedToBeRemoved?: boolean | undefined;
    metMastToBeRemoved?: boolean | undefined;
    otherBuildingOrConstructionsOnSite?: boolean | undefined;
    buildingToBeRemoved?: boolean | undefined;
    foundationsNeedToBeRemoved?: boolean | undefined;
}

export interface UpdateScenarioViewModel {
    name?: string | undefined;
    projectId?: string | undefined;
    metalProcessingProviderId?: string | undefined;
    bladeProcessingProviderId?: string | undefined;
    concreteProcessingProviderId?: string | undefined;
    currencyId?: string | undefined;
    decommissionOffshoreBottomFixedScope?: DecommissionOffshoreBottomFixedScopeViewModel | undefined;
    decommissionOffshoreFloatingScope?: DecommissionOffshoreFloatingScopeViewModel | undefined;
    decommissionOnshoreScope?: DecommissionOnshoreScopeViewModel | undefined;
    isDraft?: boolean | undefined;
    useDefaultProviders?: boolean | undefined;
    includeScrapValue?: boolean | undefined;
}

export interface NotificationViewModel {
    message: string;
    url?: string | undefined;
}

export interface TurbineSimpleItemViewModel {
    id: string;
    application: ApplicationType;
    manufacturer: Manufacturer;
    name: string;
    modelNumber?: string | undefined;
    companyName: string;
}

export enum Manufacturer {
    Other = 0,
    Acciona = 1,
    AlstomWind = 2,
    ChinaGuodianCorporation = 3,
    Clipper = 4,
    CRRC = 5,
    CSICHZWindPower = 6,
    DeWind = 7,
    DSTN = 8,
    Doosan = 9,
    Enercon = 10,
    EnronWind = 11,
    EnvisionEnergy = 12,
    Frisia = 13,
    FujiHeavyIndustries = 14,
    Gamesa = 15,
    GERenewableEnergy = 16,
    Goldwind = 17,
    Hanjin = 18,
    Hitachi = 19,
    Hyosung = 20,
    HyundaiHeavyIndustries = 21,
    InoxWind = 22,
    JapanSteelWorks = 23,
    Koncar = 24,
    MachineSaziArak = 25,
    Mapna = 26,
    MitsubishiHeavyIndustries = 27,
    NEGMicon = 28,
    Nordex = 29,
    NordicWindpower = 30,
    NovaWind = 31,
    NorthernPowerSystems = 32,
    PacWind = 33,
    Prokon = 34,
    RaumEnergyInc = 35,
    RRBEnergyLimited = 36,
    Scanwind = 37,
    SANY = 38,
    Senvion = 39,
    ShanghaiElectric = 40,
    SiemensGamesaRenewableEnergy = 41,
    Sinovel = 42,
    STXWindpower = 43,
    Suzlon = 44,
    TECO = 45,
    UNISON = 46,
    Vergnet = 47,
    Vestas = 48,
    WEG = 49,
    Windflow = 50,
    WinWinD = 51,
    WorldWind = 52,
    Xant = 53,
    Lagerwey = 54,
}

export interface TurbineItemViewModel extends TurbineSimpleItemViewModel {
    manufacturerName: string;
    ratedPower: number;
    rotorDiameter: number;
    hubHeight: number;
    windClass: WindClass;
    bladeSparMaterial: BladeSparMaterial;
    generatorType: GeneratorType;
    groupId?: string | undefined;
    isDraft: boolean;
    createdAt: Date;
    projects: ProjectSimpleItemViewModel[];
}

export enum WindClass {
    IA = 1,
    IB = 2,
    IIA = 3,
    IIB = 4,
    IIIA = 5,
    IIIB = 6,
    IV = 7,
    IC = 8,
    IIC = 9,
    IIIC = 10,
}

export enum BladeSparMaterial {
    GlassFibre = 0,
    CarbonFibre = 1,
    BalsaWood = 2,
}

export enum GeneratorType {
    GearedDoubleFedInductionGenerator = 0,
    GearedPermanentMagnetGenerator = 1,
    DirectDrivePermanentMagnetGenerator = 2,
    SyncronousGenerator = 3,
}

export interface CreateBaseTurbineViewModel {
    application: ApplicationType;
    manufacturer: Manufacturer;
    name: string;
    modelNumber: string;
    ratedPower: number;
    rotorDiameter: number;
    hubHeight: number;
    windClass: WindClass;
    bladeSparMaterial: BladeSparMaterial;
    generatorType: GeneratorType;
    isDraft: boolean;
}

export interface UpdateTurbineViewModel {
    application?: ApplicationType | undefined;
    manufacturer?: Manufacturer | undefined;
    name?: string | undefined;
    modelNumber?: string | undefined;
    ratedPower?: number | undefined;
    rotorDiameter?: number | undefined;
    hubHeight?: number | undefined;
    windClass?: WindClass | undefined;
    bladeSparMaterial?: BladeSparMaterial | undefined;
    generatorType?: GeneratorType | undefined;
    isDraft?: boolean | undefined;
}

export interface MaterialsBreakdownsViewModel {
    turbineId: string;
    blades?: MaterialsBreakdownViewModel | undefined;
    hub?: MaterialsBreakdownViewModel | undefined;
    nacelle?: MaterialsBreakdownViewModel | undefined;
    tower?: MaterialsBreakdownViewModel | undefined;
    total?: MaterialsBreakdownViewModel | undefined;
}

export interface UpdateMaterialsBreakdownViewModel {
    turbineId: string;
    steel?: number | undefined;
    castIron?: number | undefined;
    copper?: number | undefined;
    aluminium?: number | undefined;
    rareEarths?: number | undefined;
    glassFibre?: number | undefined;
    epoxyResin?: number | undefined;
    purpvcFoam?: number | undefined;
    balsaWood?: number | undefined;
    epoxyGelcoat?: number | undefined;
    silicon?: number | undefined;
    other?: number | undefined;
    componentType: ComponentType;
}

export interface PaginatedListOfTurbineItemViewModel {
    items: TurbineItemViewModel[];
    current: number;
    pageSize: number;
    total: number;
}

export interface UpdatePropertyViewModel {
    propertyName: string;
    propertyValue?: any | undefined;
}

export interface CreateUserGroup {
    name: string;
    type: GroupType;
    companyId?: string | undefined;
}

export interface UserRole {
    veracityUserId: string;
    role: UserRoleType;
}

export interface UpdateUserRole {
    updateAction: UpdateAction;
    userId: string;
    role: UserRoleType;
}

export enum UpdateAction {
    Set = 0,
    Remove = 1,
}

export interface UserInfo {
    name?: string | undefined;
    email?: string | undefined;
    id?: string | undefined;
    company?: CompanyReference | undefined;
    numberOfCompanies: number;
    verifiedEmail: boolean;
    language?: string | undefined;
    identity?: string | undefined;
    servicesUrl?: string | undefined;
    companiesUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    extensions?: { [key: string]: string; } | undefined;
    managedAccount: boolean;
    activated: boolean;
}

export interface MyUserInfo extends UserInfo {
    profilePageUrl?: string | undefined;
    messagesUrl?: string | undefined;
    identity?: string | undefined;
    servicesUrl?: string | undefined;
    companiesUrl?: string | undefined;
}

export interface ItemReference {
    name?: string | undefined;
    id?: string | undefined;
    description?: string | undefined;
    identity?: string | undefined;
}

export interface CompanyReference extends ItemReference {
    identity?: string | undefined;
    internalId?: string | undefined;
    isAdmin?: boolean | undefined;
}

export interface ProfilePicture {
    image?: string | undefined;
    mimeType?: string | undefined;
    base64?: string | undefined;
}

export interface MessageReference extends ItemReference {
    identity?: string | undefined;
}

export interface Message2 {
    name?: string | undefined;
    content?: string | undefined;
    id?: string | undefined;
    timeStamp?: string | undefined;
    channelId?: string | undefined;
    type: number;
}

export interface ServiceReference extends ItemReference {
    identity?: string | undefined;
}

export interface MyServiceReference extends ServiceReference {
    serviceUrl?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}